import work1 from "../../assets/workImages/work1.jpg";
import work2 from "../../assets/workImages/work2.jpg";
import work3 from "../../assets/workImages/work3.jpg";
import work4 from "../../assets/workImages/work4.jpg";
import work5 from "../../assets/workImages/work5.jpg";
import work6 from "../../assets/workImages/work6.jpg";
import work7 from "../../assets/workImages/work7.jpg";
import work8 from "../../assets/workImages/work8.jpg";
import work9 from "../../assets/workImages/work9.jpg";
import work10 from "../../assets/workImages/work10.jpg";
import work11 from "../../assets/workImages/work11.jpg";
import work12 from "../../assets/workImages/work12.jpg";
import work13 from "../../assets/workImages/work13.jpg";
import work14 from "../../assets/workImages/work14.jpg";
import work15 from "../../assets/workImages/work15.jpg";
import work16 from "../../assets/workImages/work16.jpg";
import work17 from "../../assets/workImages/work17.jpg";
import work18 from "../../assets/workImages/work18.jpg";
import work19 from "../../assets/workImages/work19.jpg";
import work20 from "../../assets/workImages/work20.jpg";
import work21 from "../../assets/workImages/work21.jpg";
import work22 from "../../assets/workImages/work22.jpg";
import work23 from "../../assets/workImages/work23.jpg";
import work24 from "../../assets/workImages/work24.jpg";
import work25 from "../../assets/workImages/work25.jpg";
import work26 from "../../assets/workImages/work26.jpg";
import work27 from "../../assets/workImages/work27.jpg";
import work28 from "../../assets/workImages/work28.jpg";
import work29 from "../../assets/workImages/work29.jpg";
import work30 from "../../assets/workImages/work30.jpg";
import work31 from "../../assets/workImages/work31.jpg";
import work32 from "../../assets/workImages/work32.jpg";
import work33 from "../../assets/workImages/work33.jpg";
import work34 from "../../assets/workImages/work34.jpg";
import work35 from "../../assets/workImages/work35.jpg";
import work36 from "../../assets/workImages/work36.jpg";
import work37 from "../../assets/workImages/work37.jpg";
import work38 from "../../assets/workImages/work38.jpg";
import work39 from "../../assets/workImages/work39.jpg";



export const All = [
  {
    id: 1,
    image: work22,
    alt: "brand",
    companyName: "WebX",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 2,
    image: work21,
    alt: "brand",
    companyName: "EOOYE",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 3,
    image: work20,
    alt: "logo",
    companyName: "Dangiz",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 4,
    image: work19,
    alt: "logo",
    companyName: "Dangi Graup",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 5,
    image: work18,
    alt: "logo",
    companyName: "Codesala",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 6,
    image: work17,
    alt: "commercial",
    companyName: "AppleRugs",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    id: 7,
    image: work16,
    alt: "commercial",
    companyName: "Habre",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 8,
    image: work15,
    alt: "commercial",
    companyName: "Bajrapani Constructions",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 9,
    image: work14,
    alt: "brand",
    companyName: "Bagmati",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 1,
    image: work13,
    alt: "brand",
    companyName: "Sherpa Nirman Sewa",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },{
    id: 2,
    image: work12,
    alt: "brand",
    companyName: "Gems Accounting & HR Management",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 3,
    image: work11,
    alt: "brand",
    companyName: "All-Seller Import Export",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 4,
    image: work10,
    alt: "brand",
    companyName: "AdvisorsPoint Educational Consultancy",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 5,
    image: work9,
    alt: "brand",
    companyName: "Monal Dinning PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 6,
    image: work8,
    alt: "brand",
    companyName: "Awaran Victoria",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 7,
    image: work7,
    alt: "brand",
    companyName: "Lotus Event and Reception",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 8,
    image: work6,
    alt: "brand",
    companyName: "Epeak Expedition",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 9,
    image: work5,
    alt: "brand",
    companyName: "Royal Express Cargo",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 1,
    image: work4,
    alt: "brand",
    companyName: "Atisha",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 2,
    image: work3,
    alt: "brand",
    companyName: "Easy Venture",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 3,
    image: work2,
    alt: "brand",
    companyName: "NepalGunj United Hospital",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 4,
    image: work1,
    alt: "brand",
    companyName: "Elite Soccer HK",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 5,
    image: work23,
    alt: "brand",
    companyName: "FinxLab",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 6,
    image: work24,
    alt: "brand",
    companyName: "KamalCorp",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 7,
    image: work25,
    alt: "brand",
    companyName: "SwasthyaSewa",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 8,
    image: work26,
    alt: "brand",
    companyName: "Shaishav Pathshala",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 9,
    image: work27,
    alt: "brand",
    companyName: "GB Sports",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 1,
    image: work28,
    alt: "brand",
    companyName: "Aaryaz Accessories",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 2,
    image: work29,
    alt: "brand",
    companyName: "BrightPath",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 3,
    image: work30,
    alt: "brand",
    companyName: "BeeSoul",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 4,
    image: work31,
    alt: "brand",
    companyName: "Thousand Miles",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 5,
    image: work32,
    alt: "brand",
    companyName: "YakBuck Coffee",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 6,
    image: work33,
    alt: "brand",
    companyName: "Mero Kishan",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 7,
    image: work34,
    alt: "brand",
    companyName: "KachoMaha",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 8,
    image: work35,
    alt: "brand",
    companyName: "Shyam's",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 9,
    image: work36,
    alt: "brand",
    companyName: "Tansen Holidays",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 1,
    image: work37,
    alt: "brand",
    companyName: "Designer Of The Year",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 2,
    image: work38,
    alt: "brand",
    companyName: "Wishmandu",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 3,
    image: work39,
    alt: "brand",
    companyName: "Himalayan Textile Industries",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
];

export const Construction = [
  {
    id: 1,
    image: work15,
    alt: "commercial",
    companyName: "Bajrapani Constructions",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 2,
    image: work13,
    alt: "brand",
    companyName: "Sherpa Nirman Sewa",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
];

export const Education = [
  {
    id: 1,
    image: work10,
    alt: "brand",
    companyName: "AdvisorsPoint Educational Consultancy",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 2,
    image: work26,
    alt: "brand",
    companyName: "Shaishav Pathshala",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
];

export const Transportation = [
  {
    id: 1,
    image: work11,
    alt: "brand",
    companyName: "All-Seller Import Export",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 2,
    image: work5,
    alt: "brand",
    companyName: "Royal Express Cargo",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
];
export const Finance = [
  {
    id: 1,
    image: work12,
    alt: "brand",
    companyName: "Gems Accounting & HR Management",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 2,
    image: work3,
    alt: "brand",
    companyName: "Easy Venture",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 3,
    image: work23,
    alt: "brand",
    companyName: "FinxLab",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
];

export const Enterprises = [
  {
    id: 1,
    image: work16,
    alt: "commercial",
    companyName: "Habre",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  
];
export const Technology = [
  {
    id: 1,
    image: work22,
    alt: "brand",
    companyName: "WebX",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 2,
    image: work18,
    alt: "logo",
    companyName: "Codesala",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 3,
    image: work30,
    alt: "brand",
    companyName: "BeeSoul",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
];
export const Corporate = [
  {
    id: 1,
    image: work19,
    alt: "logo",
    companyName: "Dangi Graup",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 6,
    image: work24,
    alt: "brand",
    companyName: "KamalCorp",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
];

export const ProductBusiness = [
  {
    id: 1,
    image: work20,
    alt: "logo",
    companyName: "Dangiz",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 2,
    image: work21,
    alt: "brand",
    companyName: "EOOYE",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
];

export const Sports = [
  {
    id: 1,
    image: work1,
    alt: "brand",
    companyName: "Elite Soccer HK",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 2,
    image: work27,
    alt: "brand",
    companyName: "GB Sports",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  
];
export const HealthCare = [
  {
    id: 1,
    image: work2,
    alt: "brand",
    companyName: "NepalGunj United Hospital",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 2,
    image: work25,
    alt: "brand",
    companyName: "SwasthyaSewa",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
];

export const Fashion = [
  {
    id: 1,
    image: work8,
    alt: "brand",
    companyName: "Awaran Victoria",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 2,
    image: work4,
    alt: "brand",
    companyName: "Atisha",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 3,
    image: work28,
    alt: "brand",
    companyName: "Aaryaz Accessories",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 4,
    image: work37,
    alt: "brand",
    companyName: "Designer of The Year",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
];
export const TextileIndustries = [
  {
    id: 1,
    image: work39,
    alt: "commercial",
    companyName: "Himilayan Textile Industries",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  
];
export const Electronics = [
  {
    id: 1,
    image: work38,
    alt: "commercial",
    companyName: "Wishmandu",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  
];
export const Travels = [
  {
    id: 1,
    image: work36,
    alt: "commercial",
    companyName: "Tansen Holidays",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 2,
    image: work31,
    alt: "commercial",
    companyName: "Thousend Miles",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 3,
    image: work6,
    alt: "brand",
    companyName: "Epeak Expedition",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  
];
export const FoodandBeverage = [
  {
    id: 1,
    image: work35,
    alt: "commercial",
    companyName: "Shyam's",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 2,
    image: work34,
    alt: "commercial",
    companyName: "Kacho Maha",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 3,
    image: work33,
    alt: "commercial",
    companyName: "Mero Kishan",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 4,
    image: work32,
    alt: "commercial",
    companyName: "YakBuck Coffee",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    id: 5,
    image: work9,
    alt: "brand",
    companyName: "Monal Dinning PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  }

  
];
